module.exports = __webpack_public_path__ + "img/accessibilityIcon.88aa354a.svg";